export const getEndpoint = (url) => url.split("v2")[1];
